import React, {Component} from 'react';
import background from './../img/intro-bg.jpg';
import ContactUs from '../components/contactform.js';
import Navbar from '../components/navbar.js';
import About from '../components/about.js';
import Projects from '../components/projects';


class Home extends Component {
   
    render() {
	    return (
        <div>
          <div >
            <Navbar/>
            <About/>
            <Projects/>     
            <ContactUs/>
            <a href="#" className="back-to-top"><i className="fa fa-chevron-up"></i></a>
            <div id="preloader"></div>      
          </div>
        </div>  
	     );
    }
}
export default Home;